import React, { useCallback, useEffect, useState } from 'react';
import { Pagination, Loader } from 'components/UI';
import { NoDocs } from 'theme/icon';
import GridView from './document/grid';
import TableView from './document/table';
import styles from './styles.scss';
import { IList } from './files.interface';

export const List: React.FC<IList> = ({
  themeColor = '#2787F5',
  docs,
  onDeleteDocument,
  view,
  handleDocsLength,
  isEditAccess,
  isExternalFiles = false,
  filterValue,
  isLoading,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [numberPerPage, setNumberPerPage] = useState(10);

  const paginate = useCallback(pageNumber => setCurrentPage(pageNumber), [docs, setCurrentPage]);
  const handleNumberPerPage = useCallback(numPerPage => setNumberPerPage(numPerPage), [docs, setNumberPerPage]);

  useEffect(() => {
    if (handleDocsLength) {
      handleDocsLength(docs.length);
    }
  }, [docs]);

  // @ts-ignore
  return (
    <div className={styles.listWrapper}>
      {view === 'grid' && docs.length > 0 && (
        <div className={styles.grid_wrapper}>
          {docs.map(e => (
            <GridView
              {...e}
              key={e.documentId}
              insertDate={e.insertDate}
              documentId={e.id}
              isEditAccess={isEditAccess}
              deleteDocument={onDeleteDocument}
              isPro={isExternalFiles}
              highlighter={filterValue && filterValue.length >= 3 ? filterValue : ''}
            />
          ))}
        </div>
      )}
      {view === 'table' && docs.length > 0 && (
        <div className={styles.table_wrapper}>
          <div className={styles.table_header}>
            <span className={styles.name}>Название</span>
            <span className={styles.date}>Дата обновления</span>
            <span className={styles.size}>Вес файла</span>
            <span className={styles.tag}>{isExternalFiles ? 'Тип документа' : 'Имя пользователя'}</span>
          </div>
          {docs.slice(currentPage * numberPerPage - numberPerPage, currentPage * numberPerPage).map(e => (
            <TableView
              {...e}
              key={e.documentId}
              insertDate={e.insertDate}
              documentId={e.id}
              isEditAccess={isEditAccess}
              deleteDocument={onDeleteDocument}
              isPro={isExternalFiles}
              highlighter={filterValue && filterValue.length >= 3 ? filterValue : ''}
            />
          ))}
          {docs.length > 10 && (
            <Pagination
              themeColor={themeColor}
              total={docs.length}
              paginate={paginate}
              handleNumberPerPage={handleNumberPerPage}
            />
          )}
        </div>
      )}
      {docs.length === 0 && !isLoading && (
        <div className={styles.no_data}>
          <img src={NoDocs} alt="empty" />
          <span>Документы не найдены</span>
        </div>
      )}
      {isLoading && (
        <div className={styles.no_data}>
          <Loader
            options={{ radius: 30 }}
            style={{
              width: '64px',
            }}
          />
        </div>
      )}
    </div>
  );
};
